var map = {
	"./JAMONSERRANOCASALBA.jpg": "7794",
	"./JamonIbericodeBellotaconhuesoCarrasco.jpg": "dd2a",
	"./JamonSerranoRedondoIglesias.jpg": "7663",
	"./QuesoCambozola.jpg": "df91",
	"./QuesoCasadelCampoSemicurado.jpg": "3e88",
	"./QuesoFromagerdaffinois.jpg": "65a1",
	"./QuesoGranReservaCasadelCampo.jpg": "6056",
	"./QuesoSemicuradoGarciaBaquero.jpg": "edf9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "455e";